var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 59.75C26 56.037 27.475 52.476 30.1005 49.8505C32.726 47.225 36.287 45.75 40 45.75C43.713 45.75 47.274 47.225 49.8995 49.8505C52.525 52.476 54 56.037 54 59.75H50.5C50.5 56.9652 49.3938 54.2945 47.4246 52.3254C45.4555 50.3562 42.7848 49.25 40 49.25C37.2152 49.25 34.5445 50.3562 32.5754 52.3254C30.6062 54.2945 29.5 56.9652 29.5 59.75H26ZM40 44C34.1987 44 29.5 39.3013 29.5 33.5C29.5 27.6988 34.1987 23 40 23C45.8013 23 50.5 27.6988 50.5 33.5C50.5 39.3013 45.8013 44 40 44ZM40 40.5C43.8675 40.5 47 37.3675 47 33.5C47 29.6325 43.8675 26.5 40 26.5C36.1325 26.5 33 29.6325 33 33.5C33 37.3675 36.1325 40.5 40 40.5Z",
    fill: "#007CA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 56.9349L58.8995 47.5354L62.4349 51.0717L53.0349 60.4708H49.5V56.9349ZM64.5561 48.9498L61.021 45.4147L62.7885 43.6464C62.8823 43.5527 63.0094 43.5 63.142 43.5C63.2746 43.5 63.4017 43.5526 63.4954 43.6463C63.4955 43.6464 63.4955 43.6464 63.4955 43.6464L66.3244 46.4753C66.4181 46.5691 66.4708 46.6962 66.4708 46.8288C66.4708 46.9614 66.4181 47.0885 66.3244 47.1823L64.5561 48.9498Z",
    fill: "#007CA5",
    stroke: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfile);
export default __webpack_public_path__ + "static/media/UpdateProfile.87b6265acd57ebdfd68a77e8e85a4aa1.svg";
export { ForwardRef as ReactComponent };